import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { HTML5Backend } from "react-dnd-html5-backend";
import { DndProvider } from "react-dnd";
import Listofdata from "./Listofdata";
import { PropTypes } from "prop-types";
import { useSelector } from "react-redux";
import {
  assignedBlocks,
  reassignVendorAuto,
} from "../../Services/caseManagement.service";
import useToaster from "../../customHook/useToaster";
import { isLoadingStateReducer } from "../../Redux/Slice/loginSlice";
import {
  getBlocksAsPerLobName,
  putReassignVendor,
} from "../../Services/approval.service";

const DragDrop = ({
  label,
  options = [],
  // valueOfDropDown,
  // handelChange = () => {},
  isReassign,
  reassignType,
  investigatorDetails,
  onAssign = () => {},
}) => {
  const [dropDownValue, setDropDownValue] = useState("");
  const [blockDetails, setBlockDetails] = useState([]);
  const selectedCaseId = useSelector(
    (state) => state?.CaseDescriptionSlice?.caseId
  );
  const isAllocatedCase = useSelector(
    (state) => state?.CaseDescriptionSlice?.isAllocatedCase
  );
  const { showToast } = useToaster();
  const dispatch = useDispatch();
  const lobName = useSelector((state) => state?.CaseDescriptionSlice?.lobName);
  const onAssignBlockHandler = useCallback(
    (data, remarks, resetStates) => {
      if (isReassign) {
        let investigations = [];
        data?.forEach((obj, index) => {
          let new_blocks, assigned_blocks;
          if (index === 0) {
            new_blocks =
              obj?.blocksAssigned?.filter(
                (blockId) =>
                  !investigatorDetails?.blocksAssigned?.includes(blockId)
              ) || [];
            assigned_blocks =
              obj?.blocksAssigned?.filter((blockId) =>
                investigatorDetails?.blocksAssigned?.includes(blockId)
              ) || [];
          } else {
            new_blocks = obj?.blocksAssigned || [];
            assigned_blocks = [];
          }
          let newObj = {
            ...obj,
            case_allocation_id:
              index === 0 ? investigatorDetails?.case_allocation_id : null,
            new_blocks,
            assigned_blocks,
          };
          delete newObj.blocksAssigned;
          investigations?.push(newObj);
        });

        let payload = {
          case_id: selectedCaseId,
          last_rejection_reason: remarks,
          investigations,
        };

        if (reassignType === "manual") {
          return onAssign(payload);
        }
        if (isAllocatedCase) {
          reassignVendorAuto(reassignType === "same" ? "same" : "diff", payload)
            .then((res) => {
              if (res?.success) {
                showToast(res?.message, "success", true);
                resetStates();
                onAssign();
              }
            })
            .catch((err) => {
              showToast(err?.response?.data?.message, "error", true);
            });
        } else {
          putReassignVendor(reassignType === "same" ? "same" : "diff", payload)
            .then((data) => {
              if (data?.success) {
                showToast(data?.message, "success", true);
                resetStates();
                onAssign();
              }
            })
            .catch((err) => {
              showToast(err?.response?.data?.message, "error", true);
            });
        }
        return;
      }
      assignedBlocks({ caseId: selectedCaseId, investigations: data })
        .then((data) => {
          if (data?.success) {
            showToast("Case Allocated Successfully", "success", true);
            resetStates();
            onAssign();
          }
        })
        .catch((err) => {
          showToast(err?.response?.data?.message, "error", true);
        });
    },
    [selectedCaseId, onAssign]
  );

  useEffect(() => {
    if (lobName) {
      dispatch(isLoadingStateReducer(true));
      getBlocksAsPerLobName(lobName)
        ?.then((response) => {
          dispatch(isLoadingStateReducer(false));
          if (response?.success) {
            setBlockDetails(response?.data?.blocks);
          }
        })
        ?.catch((err) => {
          dispatch(isLoadingStateReducer(false));
          showToast(err?.response?.data?.message, "error", true);
        });
    }
  }, [lobName]);

  useEffect(() => {
    if (isReassign) setDropDownValue(1);
  }, [isReassign]);
  return (
    <DndProvider backend={HTML5Backend}>
      <div style={{ width: "100%" }}>
        <Listofdata
          data={blockDetails}
          label={label}
          blockCount={`Blocks${!isReassign ? " to be assigned" : ""}: ${
            blockDetails?.length
          }`}
          options={options}
          isReassign={isReassign}
          reassignType={reassignType}
          investigatorDetails={investigatorDetails}
          valueOfDropDown={dropDownValue}
          setDropDownValue={setDropDownValue}
          handleChange={(e) => setDropDownValue(e.target.value)}
          onAssign={onAssignBlockHandler}
        />
      </div>
    </DndProvider>
  );
};
DragDrop.propTypes = {
  data: PropTypes.object,
};
export default DragDrop;
